export default "__VITE_ASSET__CQ4k$7FA__"